import actions from "@/store/actions";
import apis from "@/api";

export const fetchNonAuthActivity = (user) => {
  return async (dispatch) => {
    if (!user?.email) {
      const res = await apis.getClientIP();

      const resp = await apis.getFreeAccessUser(res);
      if (resp.status === 200) {
        dispatch(
          actions.nonAuthWatchTimeActions.fetchNonAuthActivity(resp.data.result)
        );
        return;
      }
    }
    dispatch(actions.nonAuthWatchTimeActions.fetchNonAuthActivity({}));
  };
};
